<template>
  <div class="block">
    <header></header>
    <div class="dataTable block">
      <div class="tableHead">
        <div class="tabHeadLeft">
          <h4>动态列表</h4>
        </div>
        <div class="tabHeadRight">
          <span class="labelName">状态筛选</span>
          <el-select v-model="state" @change="getList">
            <el-option
              v-for="item in StateOptions.slice(0, 6)"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <!-- <el-button class="btn-newArticle" type="primary" @click="newRelation">
            关联动态
          </el-button> -->
        </div>
      </div>
      <el-alert
        title="配置新公告请在游戏内操作，点击任意一条作品讨论的【更多】按钮即可"
        type="warning"
        show-icon
        style="margin-bottom: 20px"
      >
        <template #title>
          <el-link type="primary" @click="goTrendList"
            >配置新公告请在游戏内操作，点击任意一条作品讨论的【更多】按钮即可</el-link
          >
        </template>
      </el-alert>
      <el-table :data="list" border stripe>
        <el-table-column
          v-for="col in columns"
          :prop="col.id"
          :key="col.id"
          :label="col.label"
          :width="col.width ? col.width : 'auto'"
        >
          <template v-if="col.id === 'last_time'" #default="scope">
            {{ scope.row.last_time | formatDate }}
          </template>
          <template v-else-if="col.id === 'category'" #default="scope">
            {{ scope.row.category | getClassfy }}
          </template>
        </el-table-column>
      </el-table>
      <div class="data-filter-page">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          :page-sizes="[10, 20, 50, 100, 200]"
          :page-size="pagination.page_size"
          @size-change="allPageSizeChange"
          @current-change="allDataPageChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { formatTime } from '../../../base/CONST';
import { actConfApi } from '../../../api/actConf';
import { CLASSFY } from './CONST';
const { getTrendRelatedListByUin, updateTrendRelatedState } = actConfApi;
export default {
  data() {
    return {
      state: 0,
      StateOptions: [
        { text: '上架', value: 0 },
        { text: '下架', value: 1 },
      ],
      pagination: {
        total: 0,
        page_size: 10,
        page: 1,
      },
      list: [],
      columns: [
        { label: 'ID', id: 'id' },
        { label: '标题', id: 'title' },
        { label: '分类', id: 'category' },
        { label: '关联的地图', id: 'map_id' },
        { label: '动态ID', id: 'posting_id' },
        { label: '最后编辑时间', id: 'last_time' },
        // { label: "操作", id: "option" },
      ],
      isProd: ~location.href.indexOf('kfz.mini1.cn'),
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      getTrendRelatedListByUin({
        json: 1,
        page: this.pagination.page,
        page_size: this.pagination.page_size,
        state: this.state,
      }).then(res => {
        console.log('getTrendRelatedListByUin----', res);
        const { code, data } = res;
        if (code === 0) {
          this.list = data.list.length ? data.list : [];
          this.pagination.total = parseInt(data.total, 10);
        }
      });
    },
    handleOpts(rowInfo, type) {
      switch (type) {
        case 1: // 编辑文章
          this.editRelation(rowInfo.id);
          break;
        case 2: // 下架文章
        case 3: // 上架文章
          updateTrendRelatedState({
            id: rowInfo.id,
            state: 3 - type,
            json: 1,
          }).then(res => {
            console.log('上下架操作', res);
            if (res.code == 0) {
              this.$message
                ? this.$message.success('操作成功')
                : this.$toast('操作成功');
              this.getList();
            }
          });
          break;
      }
    },
    newRelation() {
      this.$router.push({ name: 'actTrendConf', params: { id: 0 } });
    },
    editRelation(id) {
      // TODO: editRelation
      this.$router.push({ name: 'actTrendConf', params: { id } });
    },
    allDataPageChange(page) {
      this.pagination.page = page;
      this.getList();
    },
    allPageSizeChange(pageSize) {
      this.pagination.page_size = pageSize;
      this.pagination.page = 1;
      this.getList();
    },
    errorTips(msg) {
      return this.$message ? this.$message.error(msg) : this.$toast.fail(msg);
    },
    successTips(msg) {
      return this.$message ? this.$message.success(msg) : this.$toast(msg);
    },
  },
  filters: {
    formatDate(time) {
      return formatTime(time, true);
    },
    getClassfy(val) {
      return CLASSFY[val].label;
    },
  },
};
</script>
<style src="../../../style/common-pc.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
.dataTable {
  // border-top: 1px solid #d9d9d9;
  margin: 0 auto 0;
  // padding-top: 32px;
}
.tableHead {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 27px;
  .tabHeadLeft {
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
    flex: 1 0 auto;
    h4 {
      height: 33px;
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #262626;
      line-height: 33px;
      margin-right: 20px;
    }
    span {
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #262626;
      line-height: 20px;
    }
  }
  .tabHeadRight {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .labelName {
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #262626;
      line-height: 20px;
      margin-right: 14px;
    }
    .btn-newArticle {
      margin-left: 24px;
    }
  }
}
.data-filter-page {
  margin-top: 24px;
}
</style>
